var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[(_vm.loading)?_c('w-sys-spin',{staticClass:"center"}):(_vm.pageConf)?_c('w-sys-page',{attrs:{"config":_vm.pageConf,"project-config":_vm.projectConfig}}):_c('div',[_vm._v("\n    invalid pageId\n  ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }